import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import Flex from 'components/ui/Flex';
import Spinner from 'components/ui/Spinner';
import ErrorDisplay from 'components/Error/ErrorDisplay';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';

type SearchResultsProps = {
    loading: boolean;
    error: string | null;
    hasResults: boolean;
    children: ReactNode;
};

/** Renders the loading / error / results states shared by both search steps. */
const SearchResults = ({ loading, error, hasResults, children }: SearchResultsProps) => {
    const { t } = useTranslation();

    if (loading) {
        return (
            <Flex className="mt-3" column gap="1rem" align="center">
                <Spinner size="small" color="text" />
            </Flex>
        );
    }

    if (error) {
        return <ErrorDisplay errorMessage={error} title={t('error_occurred')} icon={faExclamationTriangle} />;
    }

    return hasResults ? <>{children}</> : null;
};

export default SearchResults;
